import React, {Component, PropTypes} from 'react'
import cx from 'classnames'

export class DropdownMenu extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
      <div {...this.props} className={cx('dropdown--menu', this.props.className)}>
        {this.props.children}
      </div>
    )
  }
}
